"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "GlobalExceptionFilter", {
    enumerable: true,
    get: function() {
        return GlobalExceptionFilter;
    }
});
const _common = require("@nestjs/common");
const _nestjs = /*#__PURE__*/ _interop_require_wildcard(require("@sentry/nestjs"));
const _throttler = require("@nestjs/throttler");
const _objecthash = /*#__PURE__*/ _interop_require_default(require("object-hash"));
const _nocodbsdk = require("nocodb-sdk");
const _NocoCache = /*#__PURE__*/ _interop_require_default(require("~/cache/NocoCache"));
const _globals = require("~/utils/globals");
const _catchError = require("~/helpers/catchError");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let GlobalExceptionFilter = class GlobalExceptionFilter {
    catch(exception, host) {
        var _request_route, _exception_constructor;
        const ctx = host.switchToHttp();
        const response = ctx.getResponse();
        const request = ctx.getRequest();
        const apiVersion = request.ncApiVersion;
        // catch body-parser error and replace with NcBaseErrorv2
        if (exception.name === 'BadRequestException' && exception.status === 400 && /^Unexpected token .*? (?:in JSON|is not valid JSON)/.test(exception.message)) {
            exception = _catchError.NcError._.errorCodex.generateError(_nocodbsdk.NcErrorType.ERR_INVALID_JSON);
        }
        // try to extract db error for unknown errors
        const dbError = exception instanceof _catchError.NcBaseError ? null : (0, _catchError.extractDBError)(exception);
        // skip unnecessary error logging
        if (process.env.NC_ENABLE_ALL_API_ERROR_LOGGING === 'true' || !(dbError || exception instanceof _catchError.BadRequest || exception instanceof _catchError.AjvError || exception instanceof _catchError.Unauthorized || exception instanceof _catchError.Forbidden || exception instanceof _catchError.NotFound || exception instanceof _catchError.UnprocessableEntity || exception instanceof _catchError.TestConnectionError || exception instanceof _catchError.SsoError || exception instanceof _common.NotFoundException || exception instanceof _throttler.ThrottlerException || exception instanceof _catchError.ExternalError || exception instanceof _nocodbsdk.BadRequest || exception instanceof _nocodbsdk.NcSDKError || exception instanceof _catchError.NcBaseErrorv2 && ![
            _nocodbsdk.NcErrorType.ERR_INTERNAL_SERVER,
            _nocodbsdk.NcErrorType.ERR_DATABASE_OP_FAILED,
            _nocodbsdk.NcErrorType.ERR_UNKNOWN
        ].includes(exception.error))) this.logError(exception, request);
        if (exception instanceof _throttler.ThrottlerException) {
            const key = (0, _objecthash.default)({
                ip: request.ip,
                baseId: request.ncBaseId,
                workspaceId: request.ncWorkspaceId,
                path: request.path
            });
            const cacheKey = `throttler:${key}`;
            _NocoCache.default.get('root', cacheKey, _globals.CacheGetType.TYPE_OBJECT).then((data)=>{
                if (!data) {
                    this.logger.warn(`ThrottlerException: ${exception.message}, Path: ${request.path}, Workspace ID: ${request.ncWorkspaceId}, Base ID: ${request.ncBaseId}`);
                    _NocoCache.default.setExpiring('root', cacheKey, {
                        value: true,
                        count: 1,
                        timestamp: Date.now()
                    }, 300).catch((err)=>{
                        this.logger.error(err);
                    });
                } else {
                    data.count += 1;
                    const ttlInSeconds = Math.floor((data.timestamp + 300000 - Date.now()) / 1000);
                    if (ttlInSeconds > 0) {
                        _NocoCache.default.setExpiring('root', cacheKey, data, ttlInSeconds).catch((err)=>{
                            this.logger.error(err);
                        });
                    }
                    // log every 50th request in last 5 minutes after first
                    if (data.count % 50 === 0) {
                        this.logger.warn(`ThrottlerException: ${exception.message}, Path: ${request.path}, Workspace ID: ${request.ncWorkspaceId}, Base ID: ${request.ncBaseId}, Requests in last 5 minutes: ${data.count}`);
                    }
                }
            }).catch((err)=>{
                this.logger.error(err);
            });
        }
        // if sso error then redirect to ui with error in query parameter
        if (exception instanceof _catchError.SsoError || ((_request_route = request.route) == null ? void 0 : _request_route.path) === '/sso/:clientId/redirect') {
            if (!(exception instanceof _catchError.SsoError)) {
                this.logger.warn(exception.message, exception.stack);
            }
            // encode the query parameter
            const redirectUrl = `${request.dashboardUrl}?ui-redirect=${encodeURIComponent(`/sso?error=${encodeURIComponent(exception.message)}`)}`;
            return response.redirect(redirectUrl);
        }
        // API not found
        if (exception instanceof _common.NotFoundException) {
            this.logger.debug(exception.message, exception.stack);
            return response.status(404).json({
                msg: exception.message
            });
        }
        if (dbError) {
            const { httpStatus: httpStatus } = dbError, responsePayload = _object_without_properties_loose(dbError, [
                "httpStatus"
            ]);
            if (apiVersion === _nocodbsdk.NcApiVersion.V3) {
                return response.status(httpStatus).json(responsePayload);
            } else {
                return response.status(400).json(responsePayload);
            }
        }
        if (exception instanceof _catchError.OptionsNotExistsError && apiVersion === _nocodbsdk.NcApiVersion.V3) {
            return response.status(422).json({
                message: `Invalid option(s) "${exception.options.join(', ')}" provided for column "${exception.columnTitle}"`,
                error: 'ERR_INVALID_VALUE_FOR_FIELD'
            });
        } else if (_catchError.UniqueConstraintViolationError && typeof _catchError.UniqueConstraintViolationError === 'function' && exception instanceof _catchError.UniqueConstraintViolationError) {
            const httpStatus = apiVersion === _nocodbsdk.NcApiVersion.V3 ? 409 : 400;
            return response.status(httpStatus).json({
                error: 'FIELD_UNIQUE_CONSTRAINT_VIOLATION',
                message: exception.message,
                fieldName: exception.fieldName,
                value: exception.value
            });
        } else if (exception && typeof exception === 'object' && 'fieldName' in exception && 'value' in exception && ((_exception_constructor = exception.constructor) == null ? void 0 : _exception_constructor.name) === 'UniqueConstraintViolationError') {
            // Fallback check in case the class is not properly imported
            const httpStatus = apiVersion === _nocodbsdk.NcApiVersion.V3 ? 409 : 400;
            return response.status(httpStatus).json({
                error: 'FIELD_UNIQUE_CONSTRAINT_VIOLATION',
                message: exception.message,
                fieldName: exception.fieldName,
                value: exception.value
            });
        } else if (exception instanceof _catchError.BadRequest || (exception.getStatus == null ? void 0 : exception.getStatus.call(exception)) === 400) {
            return response.status(400).json({
                msg: exception.message
            });
        } else if (exception instanceof _catchError.Unauthorized || (exception.getStatus == null ? void 0 : exception.getStatus.call(exception)) === 401 && !(exception instanceof _catchError.NcBaseErrorv2)) {
            return response.status(401).json({
                msg: exception.message
            });
        } else if (exception instanceof _catchError.Forbidden || (exception.getStatus == null ? void 0 : exception.getStatus.call(exception)) === 403 && !(exception instanceof _catchError.NcBaseErrorv2)) {
            return response.status(403).json({
                msg: exception.message
            });
        } else if (exception instanceof _catchError.NotFound || (exception.getStatus == null ? void 0 : exception.getStatus.call(exception)) === 404 && !(exception instanceof _catchError.NcBaseErrorv2)) {
            return response.status(404).json({
                msg: exception.message
            });
        } else if (exception instanceof _catchError.AjvError) {
            if (exception.humanReadableError) {
                return response.status(400).json({
                    msg: exception.message,
                    errors: exception.errors
                });
            }
            return response.status(400).json({
                msg: exception.message,
                errors: exception.errors
            });
        } else if (exception instanceof _catchError.UnprocessableEntity || exception instanceof _nocodbsdk.BadRequest || exception instanceof _nocodbsdk.NcSDKError) {
            return response.status(422).json({
                msg: exception.message
            });
        } else if (exception instanceof _nocodbsdk.NcSDKErrorV2) {
            var _ref;
            return response.status((_ref = exception.getStatus == null ? void 0 : exception.getStatus.call(exception)) != null ? _ref : 422).json({
                error: exception.errorType,
                message: exception.message
            });
        } else if (exception instanceof _catchError.TestConnectionError) {
            return response.status(422).json({
                msg: exception.message,
                sql_code: exception.sql_code
            });
        } else if (exception instanceof _catchError.NcBaseErrorv2) {
            return response.status(exception.code).json({
                error: exception.error,
                message: exception.message,
                details: exception.details
            });
        }
        // handle different types of exceptions
        if (exception.getStatus == null ? void 0 : exception.getStatus.call(exception)) {
            response.status(exception.getStatus()).json(exception.getResponse());
        } else {
            this.captureException(exception, request);
            const msgProp = apiVersion === _nocodbsdk.NcApiVersion.V3 ? 'message' : 'msg';
            const responsePayload = {
                [msgProp]: `Something didn't work as expected. Please try again. If the problem persists, contact support.`
            };
            // Include actual error message only in development
            if (process.env.NODE_ENV !== 'production') {
                responsePayload.innerError = {
                    [msgProp]: (exception == null ? void 0 : exception.message) || 'An unexpected error occurred',
                    stack: exception == null ? void 0 : exception.stack
                };
            }
            response.status(500).json(responsePayload);
        }
    }
    captureException(exception, _request) {
        _nestjs.captureException(exception);
    }
    logError(exception, _request) {
        this.logger.error(exception.message, exception.stack);
    }
    constructor(){
        this.logger = new _common.Logger(GlobalExceptionFilter.name);
    }
};
GlobalExceptionFilter = _ts_decorate([
    (0, _common.Catch)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [])
], GlobalExceptionFilter);
